export const iframeMapper = ({
  pageBlockUI: [
    {
      ui: { disableGutters, element, maxWidth, mode },
    },
  ],
  iframeTitle,
  ...rest
}) => ({
  pageBlockUI: {
    disableGutters,
    element,
    maxWidth,
    mode,
  },
  title: iframeTitle,
  ...rest,
});
